import { Component } from '@angular/core';
import { LocalComponent } from '../local/local.component';
import { FormControl, Validators, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-foreigner',
  templateUrl: './foreigner.component.html',
  styleUrls: ['./foreigner.component.css'],
})
export class ForeignerComponent extends LocalComponent {
  thirdPartyInfo:FormControl;
  socialSecurityInfo:FormControl;
  createForm () {
    this.local = new FormControl(false);
    this.registration_id = new FormControl(null, [Validators.required, Validators.minLength(13), Validators.maxLength(13)]);
    this.name = new FormControl(null, [Validators.required]);
    this.personalInfo = new FormControl(false, [Validators.requiredTrue]);
    this.thirdPartyInfo = new FormControl(false, [Validators.requiredTrue]);
    this.socialSecurityInfo = new FormControl(false, [Validators.requiredTrue]);

    this.form = new FormGroup({
      local:this.local,
      registration_id:this.registration_id,
      name:this.name,
      personalInfo:this.personalInfo,
      thirdPartyInfo:this.thirdPartyInfo,
      socialSecurityInfo:this.socialSecurityInfo,
    });

  }


}
